module.exports = __webpack_public_path__ + "static/kadry_i_place-01-62afdc4f98c2e4595445b95294257841.png";